export default "<p>\r\n\t<b>Mail App:</b> - Coming soon in the following update.\r\n</p>\r\n"